import { Component, Input, forwardRef, Output, EventEmitter, ContentChild, TemplateRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StringFormControl } from '@lc/core';
import { MatFormField, MatLabel, MatInput, MatHint, MatError, MatSuffix } from '@angular/material/input';
import { NgIf, NgTemplateOutlet } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';
import { E2eIdDirective } from '@lc/ui/lib/core';
import { Mask } from '../input-masks';
import { InputField } from '../input-field';

@Component({
  selector: 'lc-textbox',
  templateUrl: './textbox.component.html',
  styleUrls: ['./textbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextboxComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => TextboxComponent),
      multi: true,
    },
  ],
  imports: [
    MatFormField,
    MatLabel,
    NgTemplateOutlet,
    MatInput,
    FormsModule,
    NgxMaskDirective,
    ReactiveFormsModule,
    MatHint,
    MatError,
    MatSuffix,
    NgIf,
    E2eIdDirective,
  ],
})
export class TextboxComponent extends InputField {
  @Input() label: string;

  @Input() placeholder = '';

  @Input() readonly = false;

  @Input() required = false;

  @Input() inputMask: Mask;

  @Input() hint: string;

  @Input() suffix: string;

  @Input()
    maskDropSpecialCharacters = true; // # choose if mask will drop special character in the model, or not, default value is true

  @Output() readonly blur = new EventEmitter<void>();

  @ContentChild('label')
    labelTemplate: TemplateRef<any>;

  @ContentChild('hint')
    hintTemplate: TemplateRef<any>;

  @ContentChild('suffix')
    suffixTemplate: TemplateRef<any>;

  public onBlur() {
    if (this.formControl && this.formControl instanceof StringFormControl) {
      this.formControl.onLostFocus();
    }

    this.blur.emit();
    this.executeOnTouched();
  }
}
